module.exports = __webpack_public_path__ + "static/media/error.c68a73c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/history-icons/error.svg
// module id = 832
// module chunks = 0